import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { MemberStateService } from './member-state.service';

// Returning to STEP2 would release the slots currently being confirmed by the API.
export const registrationPendingGuard: CanDeactivateFn<unknown> = () =>
  !inject(MemberStateService).get().showProcess;
